import { createSelector } from 'reselect';

const emptyArray = [];
const offers = (state) => state.offers.list;
const goalActions = (state) => state.goalActions.list;
const postbacks = (state) => state.postbacks.list.data;
const goals = (state) => state.goals.list;
const location = (state) => state.routingCompat;

export const getOffers = createSelector(
    offers,
    (offers = []) => {
        return offers;
    }
);

export const getGoalActions = createSelector(
    goalActions,
    (goalActions = []) => {
        let list = [];

        goalActions.map((item) => {
            list.push({
                ...item,
                actionId: item.action.id,
                title: `(${item.action.id}) ${item.action.title}`
            });
        });

        return list;
    }
);

export const getGoals = createSelector(
    goals,
    (goals = []) => {
        return goals;
    }
);

export const getGoalActionIds = createSelector(
    postbacks,
    location,
    (postbacks = [], location = {}) => {
        const isCreate = location.pathname === '/postback/create';

        if (isCreate) return [];

        return postbacks[0] ? postbacks[0].config.goal_action_ids || emptyArray : emptyArray;
    }
);
